import { useEffect } from "react";
import { bool, func } from "prop-types";

import trackEvent from "../tracking/track-event";

import NetChangeExample from "./NetChangeExample";
import Portal from "../../components/portal/Portal";

import { Modal, Typography } from "@uhc-tempo/components";
const { Content, Header, Title } = Modal;
const { Paragraph } = Typography;

export default function ModalNetChangeSpecialty({ handleOpen, open, ...rest }) {
  useEffect(() => {
    if (open) {
      trackEvent({ action: "status_net_change_specialty_overlay" });
    }
  }, [open]);

  return (
    <Portal id="net-change-medical">
      {open && (
        <Modal contentId="net-change-medical-modal" handleClose={handleOpen}>
          <Header>
            <Title className="ua-font-weight-normal ua-padding-sm-top">
              Specialty net change
            </Title>
          </Header>
          <Content>
            <Paragraph>
              Specialty net change is calculated by subtracting the number of
              cancelled specialty memberships from the number of sold specialty
              memberships (new sales). This number is{" "}
              <strong className="tds-text__paragraph--bold">
                always changing
              </strong>{" "}
              based on your agency’s evolving book of business with UHC.
            </Paragraph>
          </Content>
          <NetChangeExample enrolled={100} type="specialty" {...rest} />
        </Modal>
      )}
    </Portal>
  );
}

ModalNetChangeSpecialty.propTypes = {
  handleOpen: func.isRequired,
  open: bool,
};
